module.exports = __webpack_public_path__ + "img/use-a-template.a41da5e.png";